import { createFileRoute } from '@tanstack/react-router';
import { PaginaEmDesenvolvimento } from '@/components/layout/PaginaEmDesenvolvimento';

export const Route = createFileRoute('/_admin/relatorios')({
  component: RelatoriosPage,
});

function RelatoriosPage() {
  return <PaginaEmDesenvolvimento label="Relatórios" />;
}
